import { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import '../../assets/css/components/program.css';
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import { PromotionsAmplifiers, PromotionsHeader, PromotionsPreview, SubmissionError, NewPromotionsInfo, PromotionReview } from '../../components/PromotionsComponents';
import { Formik, Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { responseHandler, Loading } from '../../components/utility/Utility';
import { InitiateTutorial } from '../../components/Onboarding';

export default function UpdatePromotion() {
  const {handleSignOut, getJwtToken, userProfile} = useContext(AuthContext);
  const {id} = useParams();
  const [tutorial, setTutorial] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [promotion, setPromotion] = useState(false);
  const [conflictingPromotions, setConflictingPromotions] = useState(false);
  const [dynamicName, setDynamicName] = useState('');
  const [previewValues, setPreviewValues] = useState(false);
  const [activeAmplifier, setActiveAmplifier] = useState('announcementBar');
  const [announcementStatus, setAnnouncementStatus] = useState(false);
  const [productStatus, setProductStatus] = useState(false);
  const [collectionStatus, setCollectionStatus] = useState(false);
  const [cartStatus, setCartStatus] = useState(false);
  // const [currentValues, setCurrentValues] = useState(false)
  const [submitting, setSubmitting] = useState(false);
  const prevValues = useRef(false);

  // useEffect(() => {
  //   console.log(tutorial);
  // }, [tutorial])
  useEffect(() => {
    const getPromotionData = async () => {
      const tutorialParam = searchParams.get('tutorial');
      if (tutorialParam === 'true') setTutorial(1);
      try {
        const token = await getJwtToken();
        const res = await axios.get('https://api.amplifyloyalty.com/app/stores/promotions',
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            id: id
          }
        });
        
        if (res.data.name === 'BadRequestError') {
          // handleSignOut();
        } else if (res.data[0].status !== 'draft') {
          navigate(`/app/promotions/${id}/reporting`);
        } else {
          let result = res.data[0];
          setConflictingPromotions(res.data.slice(1));
          setPromotion(result);
          if (location.pathname.includes('amplifiers') || location.pathname.includes('review')) {
            setDynamicName(result.name);
          }
          // setAnnouncementStatus(promotion.amplifiers.announcement.status);
          // setProductStatus(promotion.amplifiers.product.status);
          // setCollectionStatus(promotion.amplifiers.collection.status);
          prevValues.current = {
            announcement_status: result.amplifiers.announcement.status,
            announcement_sticky: result.amplifiers.announcement.sticky,
            announcement_text: result.amplifiers.announcement.text,
            announcement_font_size: result.amplifiers.announcement.font_size,
            announcement_font_color: result.amplifiers.announcement.background_color,
            announcement_url: result.amplifiers.announcement.url,
            collection_status: result.amplifiers.collection.status,
            collection_text: result.amplifiers.collection.text,
            collection_font_size: result.amplifiers.collection.font_size,
            collection_font_color: result.amplifiers.collection.font_color,
            collection_points_color: result.amplifiers.collection.points_color,
            product_status: result.amplifiers.product.status,
            product_text: result.amplifiers.product.text,
            product_font_size: result.amplifiers.product.font_size,
            product_font_color: result.amplifiers.product.font_color,
            product_points_color: result.amplifiers.product.points_color,
            cartpoints_point_status: result.amplifiers.cart.points_display.point_status,
            cartpoints_text: result.amplifiers.cart.points_display.text,
            cartpoints_font_size: result.amplifiers.cart.points_display.font_size,
            cartpoints_font_color: result.amplifiers.cart.points_display.font_color,
            cartpoints_points_color: result.amplifiers.cart.points_display.points_color,
            cartpoints_background_color: result.amplifiers.cart.points_display.background_color,
            cartpoints_border_color: result.amplifiers.cart.points_display.border_color,
            cartredemptions_redemption_status: result.amplifiers.cart.redemptions.redemption_status,
            // cartredemptions_login_message: result.amplifiers.cart.redemptions.login_message,
            cartredemptions_redemption_font_size: result.amplifiers.cart.redemptions.redemption_font_size,
            // cartredemptions_show_coupons: result.amplifiers.cart.redemptions.show_coupons,
            cartredemptions_redemption_font_color: result.amplifiers.cart.redemptions.redemption_font_color,
            cartredemptions_redemption_background_color: result.amplifiers.cart.redemptions.redemption_background_color
          }
          // setCurrentValues(prevValues.current);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getPromotionData();

    // On any change of any form input, update the preview values
    // Set interval for every 15 seconds to check current values against initial and then
    // last saved values to see if there's an update and then send new values to save
    // setInterval(() => {
    //   let prev = Object.keys(prevValues.current).map(k => {
    //     if (prevValues.current[k] === currentValues[k]) {
    //       return true
    //     }
    //   });
    //   if (prev.length !== Object.keys(prevValues.current).length) {
    //     console.log('Mismatch');
    //   } else {
    //     console.log("passed");
    //   }
    // }, 15000);
  }, [location.pathname])

  const HandleChange = () => {
    const { values } = useFormikContext();
    useEffect(() => {
      // setCurrentValues(values);
      setPreviewValues(values);
      setAnnouncementStatus(values.announcement_status);
      setProductStatus(values.product_status);
      setCollectionStatus(values.collection_status);
      setCartStatus(values.cartpoints_point_status || values.cartredemptions_redemption_status ? true : false);
    }, [values]);
    return null;
  }

  const disableReviewInputs = (dsbl) => {
    const btns = [
      ...document.querySelectorAll('.update-promotion-review__schedule-button'), 
      ...document.querySelectorAll('.update-promotion-review__submit-button')
    ];
    btns.forEach(btn => btn.disabled = dsbl);
  }

  return (
    <div className="main" style={{position: "relative"}}>
      <PromotionsHeader dynamicName={dynamicName} promotion={promotion} />
      {(promotion && !location.pathname.includes('amplifiers') && !location.pathname.includes('review')) && 
        <NewPromotionsInfo 
          promotion={promotion} 
          setPromotion={setPromotion} 
          setDynamicName={setDynamicName} 
          conflictingPromotions={conflictingPromotions} 
          tutorial={tutorial}
          setTutorial={setTutorial}
          timezone={userProfile?.store?.settings?.timezone}
        />
      }
      {location.pathname.includes('amplifiers') && 
        <section className="update-promotion-amplifiers-settings centralize">
          {promotion && 
            <Formik
              initialValues={{
                announcement_status: promotion.amplifiers.announcement.status,
                announcement_sticky: promotion.amplifiers.announcement.sticky,
                announcement_text: promotion.amplifiers.announcement.text,
                announcement_font_size: promotion.amplifiers.announcement.font_size,
                announcement_font_color: promotion.amplifiers.announcement.font_color,
                announcement_background_color: promotion.amplifiers.announcement.background_color,
                announcement_url: promotion.amplifiers.announcement.url,
                collection_status: promotion.amplifiers.collection.status,
                collection_text: promotion.amplifiers.collection.text,
                collection_font_size: promotion.amplifiers.collection.font_size,
                collection_font_color: promotion.amplifiers.collection.font_color,
                collection_points_color: promotion.amplifiers.collection.points_color,
                product_status: promotion.amplifiers.product.status,
                product_text: promotion.amplifiers.product.text,
                product_font_size: promotion.amplifiers.product.font_size,
                product_font_color: promotion.amplifiers.product.font_color,
                product_points_color: promotion.amplifiers.product.points_color,
                cartpoints_point_status: promotion.amplifiers.cart.points_display.point_status,
                cartpoints_text: promotion.amplifiers.cart.points_display.text,
                cartpoints_font_size: promotion.amplifiers.cart.points_display.font_size,
                cartpoints_font_color: promotion.amplifiers.cart.points_display.font_color,
                cartpoints_points_color: promotion.amplifiers.cart.points_display.points_color,
                cartpoints_background_color: promotion.amplifiers.cart.points_display.background_color,
                cartpoints_border_color: promotion.amplifiers.cart.points_display.border_color,
                cartredemptions_redemption_status: promotion.amplifiers.cart.redemptions.redemption_status,
                // cartredemptions_login_message: promotion.amplifiers.cart.redemptions.login_message,
                cartredemptions_redemption_font_size: promotion.amplifiers.cart.redemptions.redemption_font_size,
                // cartredemptions_show_coupons: promotion.amplifiers.cart.redemptions.show_coupons,
                cartredemptions_redemption_font_color: promotion.amplifiers.cart.redemptions.redemption_font_color,
                cartredemptions_redemption_background_color: promotion.amplifiers.cart.redemptions.redemption_background_color,
                cartredemptions_redemption_border_color: promotion.amplifiers.cart.redemptions.redemption_border_color
              }}
              onSubmit={async (values, {resetForm}) => {
                if (tutorial !== 4) {
                  values._id = id;
                  let inputs = [...document.querySelectorAll('input'), ...document.querySelectorAll('.input'), document.querySelector('.amplifier-preview__continue-button')];
                  inputs.forEach(input => input.setAttribute("disabled", true));
                  setSubmitting(true);
                  try {
                    const token = await getJwtToken();
                    const res = await axios.put(
                      'https://api.amplifyloyalty.com/app/stores/promotions',
                      values,
                      {
                        headers: { Authorization: `Bearer ${token}` },
                        params: {
                          section: 'amplifiers'
                        }
                      }
                    );
                    if (res.data.name === 'BadRequestError') {
                      // handleSignOut();
                    } else {
                      navigate(`/app/promotions/${id}/review${tutorial === 5 ? '?tutorial=true' : ''}`);
                      // show last time updated
                    }
                  } catch (err) {
                    // responseHandler(err)
                    setSubmitting(false);
                    inputs.forEach(input => input.setAttribute("disabled", false));
                    console.log(err);
                  }
                }
              }}
            >
              <Form className='update-promotion-amplifiers__container'>
                <PromotionsAmplifiers 
                  promotion={promotion}
                  activeAmplifier={activeAmplifier}
                  setActiveAmplifier={setActiveAmplifier}
                  announcementStatus={announcementStatus}
                  productStatus={productStatus}
                  collectionStatus={collectionStatus}
                  cartStatus={cartStatus}
                  submitting={submitting}
                  tutorial={tutorial}
                  setTutorial={setTutorial}
                />
                <PromotionsPreview 
                  previewValues={previewValues}
                  activeAmplifier={activeAmplifier} 
                  tutorial={tutorial}
                  setTutorial={setTutorial}
                />
                <HandleChange />
              </Form>
            </Formik>
          }
        </section>
      }
      {location.pathname.includes('review') && promotion && 
        <PromotionReview 
          promotion={promotion} 
          disableReviewInputs={disableReviewInputs} 
          id={id} 
          tutorial={tutorial}
          setTutorial={setTutorial}
          timezone={userProfile?.store?.settings?.timezone}
        />
      }
    </div>
  )
}